module.exports = __webpack_public_path__ + "static/media/profile_photo.5be9f977.jpeg";